import React from 'react'
import { Route, Switch } from 'react-router-dom'
import {
  APP_ROOT,
  CONFIRM_EMAIL_PATH,
  CREATE_ACCOUNT,
  CREATE_INVESTOR_ACCOUNT,
  CREATE_MASTER_ACCOUNT,
  CREATE_PAMM_FUND,
  UPGRADE_TIER_PATH
} from './constants/routes'
import { Intro } from './components/Intro/Intro'
import { CreateAccount } from './components/CreateAccount/CreateAccount'
import { Tier1CompleteRegister } from './components/Tier1CompleteRegister/Tier1CompleteRegister'
import UpgradeTier from './components/UpgradeTier'
import { CreateInvestorAccount } from './components/CreateInvestorAccount/CreateInvestorAccount'
import { CreatePammFund } from './components/CreatePammFund/CreatePammFund'

export const RouterComponent = () => {
  return (
    <Switch>
      <Route exact path={APP_ROOT} component={Intro} />
      <Route path={CREATE_ACCOUNT} component={CreateAccount} />
      <Route path={CREATE_MASTER_ACCOUNT} render={(props) => <CreateAccount {...props} processingMode />} />
      <Route path={CREATE_INVESTOR_ACCOUNT} component={CreateInvestorAccount} />
      <Route path={CONFIRM_EMAIL_PATH} component={Tier1CompleteRegister} />
      <Route path={UPGRADE_TIER_PATH} component={UpgradeTier} />
      <Route path={CREATE_PAMM_FUND} component={CreatePammFund} />
    </Switch>
  )
}
